import React from "react";
import styles from "./Footer.module.scss";
import Layout from "../Layout/Layout";
import { Logo, Link, Subscribe } from "../../elements";
import THEME from "../../../state/theme";
import { useCustomState } from "../../../state/state";
import Footer from '../../../assets/footer_logo.png';
import FooterLogo from "../../elements/Logo/FooterLogo";


export default () => {
  const state = useCustomState()[0];

  const servicesList = state.data.services
    .map((item, index) => (
      <Link
        key={index}
        url={"/services/" + item.id}
        hoverStyle={{ color: THEME.color }}
      >
        <i className="las la-angle-right" />
        {item.title}
      </Link>
    ))
    .slice(0, 5);

  const linkList = state.data.fast_links.map((item, index) => (
    <Link key={index} url={item.url} hoverStyle={{ color: THEME.color }}>
      <i className="las la-angle-right" />
      {item.title}
    </Link>
  ));
  return (
    <Layout col="1" padding style={{ background: "#272d2e" }}>
      <div className={styles.footer}>
        <div className={styles.logo_area}>
          <FooterLogo url={Footer} dark />
          <p>
            The Entrepreneurship Cell, IIIT Surat aims to inculcate and nurture the raw ideas
            and skills of the students, willing to convert their ideas into product and to
            emerge as a leading entrepreneur.
          </p>
          <div className={styles.social}>
            <a href="https://in.linkedin.com/company/e-cell-iiit-surat" target="_blank"><i className="lab la-linkedin-in" /></a>
            <a href="https://www.instagram.com/ecell_iiits/" target="_blank"><i className="lab la-instagram" /></a>
            <a href="https://www.facebook.com/ecell.iiits/" target="_blank"><i className="lab la-facebook-f" /></a>
            <a href="https://twitter.com/ecell_iiits" target="_blank"><i className="lab la-twitter" /></a>
          </div>
        </div>

        <div className={styles.link_area}>
          {/* <div className={styles.links}>
            <h4>Services</h4>
            {servicesList}
          </div>
          <div className={styles.links}>
            <h4>Fast Links</h4>
            {linkList}
          </div> */}
        </div>

        <div className={styles.subscribe}>
          <h4>Get connected with Ruminate.</h4>
          <Subscribe />
          <p>
            Trust us, spaming is never an option for us!
          </p>
        </div>
      </div>
    </Layout>
  );
};
